import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../../components/CheckoutForm/CheckoutForm";
const stripePromise = loadStripe("pk_test_51QeFOORsbPlqI3NS1LRPh8Nfqvd0Aj6UKPXDrUIcdFgaHqmFowgeLjNnA0cF8wVArdOzEd1nfe52OOVl6hMDKZvz00xeG1bFH2");

const Stripe = () => {
    return (
        <div className="flex items-center justify-center py-14">
            <div className="w-full max-w-4xl bg-[#F2F2F282] p-20 rounded-md shadow-lg">
                <Elements stripe={stripePromise}>
                    <CheckoutForm />
                </Elements>
            </div>
        </div>
    );
}
export default Stripe;




